module.exports = __webpack_public_path__ + "static/flowertowel-5701249e165d411465028ec3fccd9a90.png";